// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { Grid, Form } from 'semantic-grab-ui/src';
import formComponent from 'components/decorators/form_component';
import FormInputWithError from 'components/form/FormInputWithError';
import type { TridentCampaignDetails } from 'types/trident-campaigns';
import './TreatmentActionForm.scss';

type Props = {
  model: TridentCampaignDetails,
  currentNode: string,
  subActionIndex: number,
  handleInputChange: Function,
  handleControlBlur: Function,
};

@formComponent()
export default class ActionOptInChallenge extends Component {
  props: Props;

  render() {
    const { model, currentNode, subActionIndex } = this.props;
    const challengeIDMetaKey = `nodes.${currentNode}.data.${subActionIndex}.meta.optInChallengePayload.challengeID`;
    return (
      <div className="treatment-form">
        <div>
          <br />
          <Form>
            <Grid columns="equal">
              <Grid.Column width={5}>
                <FormInputWithError
                  name={challengeIDMetaKey}
                  {...this.props}
                >
                  <Form.Input
                    required
                    label="Challenge ID"
                    value={_.get(model, challengeIDMetaKey)}
                    onChange={this.props.handleInputChange}
                    onBlur={this.props.handleControlBlur}
                  />
                </FormInputWithError>
              </Grid.Column>
            </Grid>
          </Form>
        </div>
      </div>
    );
  }
}
